(function () {
    "use strict";

    angular.module("sempraWebapp").factory("savingsActions", savingsActionsFactory);

    /** @ngInject */
    function savingsActionsFactory(api) {
        return {
            getSavingsUsers: getSavingsUsers,
            deactivateSavingsAccount: deactivateSavingsAccount,
            createSavingsAccount: createSavingsAccount
        };

        function getSavingsUsers(page, pageSize, orderBy, order, search) {
            return api.getSavingsUsers(page, pageSize, orderBy, order, search);
        }

        function deactivateSavingsAccount(accountId) {
            return api.deactivateSavingsAccount(accountId);
        }

        function createSavingsAccount(savingsData) {
            return api.createSavingsAccount(savingsData);
        }
    }
})();
